import firebaseConfig from "../layouts/caterpillar.firebase.config.js";
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  apiDomain: "https://dev.stringconsultants.com/api/",
  firebaseCDN: firebaseConfig,
  NODE_ENV: "Caterpillar",
};
